import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=f52a85d4&scoped=true&"
import script from "./edit-form.vue?vue&type=script&lang=js&"
export * from "./edit-form.vue?vue&type=script&lang=js&"
import style0 from "./edit-form.vue?vue&type=style&index=0&id=f52a85d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52a85d4",
  null
  
)

export default component.exports